import React from 'react'

import { Grid, TextField, Button, Paper, Box, Typography, CircularProgress } from '@material-ui/core'
import { useMutation } from '@apollo/react-hooks'
import { CREATE_TOKEN, UPDATE_PASSWORD } from './queries'
import decodeJWT from 'jwt-decode'
import { useHistory, Link } from 'react-router-dom'
import { useStyles } from './styles'
import { toast } from 'react-toastify'
// import FooterLogos from  '../../components/FooterLogos'
import { validatePassword } from '../../utils/functions'

function LoginPage() {
  const classes = useStyles()
  const [email, setEmail] = React.useState('')
  const [password, setPassword] = React.useState('')
  const [newPassword, setNewPassword] = React.useState('')
  const [newPasswordConfirmation, setNewPasswordConfirmation] = React.useState('')
  const [createToken, { loading, error }] = useMutation(CREATE_TOKEN)
  const [updatePassword, { loading: updatingPassword, error: errorUpdatingPassword }] = useMutation(UPDATE_PASSWORD)
  const [firstLogin, setFirstLogin] = React.useState(false)
  const history = useHistory()

  if (!firstLogin && localStorage.getItem('token')) {
    history.replace('/admin')
  }

  if (error) {
    toast.error('E-mail ou senha incorretos ou não autorizados!')
    history.replace('/')
  }

  if (errorUpdatingPassword) {
    toast.error('Ocorreu um erro ao atualizar a sua senha')
    history.replace('/')
  }

  const handleSubmit = () => {
    const variables = {
      email,
      password,
    }

    createToken({
      variables,
      update(cache, { data: { createToken }}) {
        const token = createToken.token
        const decodedToken = decodeJWT(token)
        localStorage.setItem('token', token)
        localStorage.setItem('userId', decodedToken.sub)
        if (!decodedToken.last_updated_password_at) {
          setFirstLogin(true)
        }
        cache.writeData({
          data: {
            currentUserID: decodedToken.sub,
            currentUserProfile: decodedToken.profile,
          }
        })
      }
    })
  }

  const handleUpdatePassword = () => {
    const variables = {
      newPassword,
    }

    updatePassword({
      variables,
      update(cache, { data: { updatePassword }}) {
        localStorage.setItem('token', updatePassword.token)
        setFirstLogin(false)
      }
    })
  }

  const passwordMessage = validatePassword(newPassword, newPasswordConfirmation, password)

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      direction="column"
      style={{ height: '100%' }}
    >
      <Grid
        item
        xs={ 10 }
        md={ 7 }
        lg={ 5 }
        style={{ position: 'absolute', top: '10%' }}>
        <Paper elevation={ 1 } className={ classes.wrapper }>
          <Grid
            container
            justify="center"
            alignItems="center"
          >

            <Grid item xs={ 10 } className={ classes.title }>
              <Box mt={ 1 }>
                <Typography variant="h2" noWrap><b>ISE</b>B3</Typography>
                <Box mt={ 1 } textAlign="center">
                  <Typography variant="p" className={ classes.subtitle }>
                      Obrigado por acessar a plataforma de Consulta Pública do questionário ISE B3 2024!
                  </Typography>
                </Box>
                <Box mt={ 2 } textAlign="left">
                  <Typography variant="p" className={ classes.subtitle }>
                    A participação nesta consulta é fácil, gratuita e aberta a todos interessados. Informe abaixo seu e-mail e senha, ou
                    { ' ' }
                    <Link to="/signup" className={ classes.signUpLink }>
                       clique aqui para se cadastrar.
                    </Link>
                  </Typography>
                </Box>
              </Box>
            </Grid>

            {
              !firstLogin
                ? (
                  <>
                    <Grid item xs={ 10 } className={ classes.field }>
                      <TextField
                        autoFocus
                        fullWidth
                        value={ email }
                        onChange={ event => setEmail(event.target.value) }
                        onKeyPress={ event =>
                          email &&
                          password &&
                          event.key === 'Enter' &&
                          handleSubmit(event)
                        }
                        placeholder="E-mail"
                      />
                    </Grid>
                    <Grid item xs={ 10 } className={ classes.field }>
                      <TextField
                        fullWidth
                        placeholder="Senha"
                        type="password"
                        value={ password }
                        onKeyPress={ event =>
                          email &&
                          password &&
                          event.key === 'Enter' &&
                          handleSubmit(event)
                        }
                        onChange={ event => setPassword(event.target.value) }
                      />
                    </Grid>
                    <Grid item xs={ 4 } className={ classes.submit }>
                      <Button
                        fullWidth
                        onClick={ handleSubmit }
                        disabled={ !email || !password }
                      >
                        {
                          loading
                            ? <CircularProgress size={ 25 } />
                            : 'Entrar'
                        }
                      </Button>
                    </Grid>

                    <Grid item xs={ 10 } className={ classes.signUpLinkWrapper }>
                      <Link to="/forgot-my-password" className={ classes.forgotPasswordLink }>
                        Esqueci minha senha.
                      </Link>
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid item xs={ 10 } className={ classes.field }>
                      <TextField
                        autoFocus
                        fullWidth
                        value={ newPassword }
                        onChange={ event => setNewPassword(event.target.value) }
                        type="password"
                        placeholder="Digite a sua nova senha"
                      />
                    </Grid>
                    <Grid item xs={ 10 } className={ classes.field }>
                      <TextField
                        fullWidth
                        placeholder="Confirme a sua nova senha"
                        type="password"
                        value={ newPasswordConfirmation }
                        onChange={ event => setNewPasswordConfirmation(event.target.value) }
                      />
                    </Grid>
                    <Grid
                      item
                      xs={ 10 }
                      className={ classes.newPasswordInvalidMessage }
                    >
                      <Typography align="center">
                        { passwordMessage }
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={ newPassword === newPasswordConfirmation ? 6 : 10 }
                      className={ classes.submit }
                    >
                      <Button
                        fullWidth
                        onClick={ handleUpdatePassword }
                        disabled={
                          !newPassword ||
                          !newPasswordConfirmation ||
                          newPassword !== newPasswordConfirmation ||
                          !!passwordMessage
                        }
                      >
                        {
                          updatingPassword
                            ? <CircularProgress size={ 25 } />
                            : 'Atualizar Senha'
                        }
                      </Button>
                    </Grid>
                  </>
                )
            }

            { /* <FooterLogos /> */ }
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  )
}

export default LoginPage
